import {useIntl} from 'react-intl'
import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {MegaMenu} from './MegaMenu'

export function MenuInner() {
  const intl = useIntl()
  return (
    <>
      {/*<MenuItem title={intl.formatMessage({id: 'MENU.DASHBOARD'})} to='/dashboard' />*/}
      {/*<MenuItem title='Layout Builder' to='/builder' />*/}
      {/*<MenuInnerWithSub*/}
      {/*  title='Crafted'*/}
      {/*  to='/crafted'*/}
      {/*  menuPlacement='bottom-start'*/}
      {/*  menuTrigger='click'*/}
      {/*>*/}
      {/*  /!* PAGES *!/*/}

      {/*  /!* ACCOUNT *!/*/}
      {/*  <MenuInnerWithSub*/}
      {/*    title='Accounts'*/}
      {/*    to='/crafted/accounts'*/}
      {/*    fontIcon='bi-person'*/}
      {/*    hasArrow={true}*/}
      {/*    menuPlacement='left-start'*/}
      {/*    menuTrigger={`{default:'click', lg: 'hover'}`}*/}
      {/*  >*/}
      {/*    <MenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />*/}
      {/*    <MenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />*/}
      {/*  </MenuInnerWithSub>*/}

      {/*  /!* ERRORS *!/*/}
      {/*  <MenuInnerWithSub*/}
      {/*    title='Errors'*/}
      {/*    to='/error'*/}
      {/*    fontIcon='bi-sticky'*/}
      {/*    hasArrow={true}*/}
      {/*    menuPlacement='left-start'*/}
      {/*    menuTrigger={`{default:'click', lg: 'hover'}`}*/}
      {/*  >*/}
      {/*    <MenuItem to='/error/404' title='Error 404' hasBullet={true} />*/}
      {/*    <MenuItem to='/error/500' title='Error 500' hasBullet={true} />*/}
      {/*  </MenuInnerWithSub>*/}


      {/*</MenuInnerWithSub>*/}


      {/*<MenuInnerWithSub*/}
      {/*  isMega={true}*/}
      {/*  title='Mega menu'*/}
      {/*  to='/mega-menu'*/}
      {/*  menuPlacement='bottom-end'*/}
      {/*  menuTrigger='click'*/}
      {/*>*/}
      {/*  <MegaMenu />*/}
      {/*</MenuInnerWithSub>*/}
    </>
  )
}
